import axios from 'axios';
const BASE_URL = 'api/users/';

// Первичная настройка модуля - авторизованный пользователь (при загрузке SPA)
const localAuthToken = localStorage.getItem('authToken');
let localUser = null;
if (localAuthToken) {
  axios.defaults.headers.common['authToken'] = localAuthToken;
  
  localUser = {
    _id: localStorage.getItem('userId'),
    name: localStorage.getItem('userName'),
    role: localStorage.getItem('userRole')
  }; 
}

let exports = {};
exports.namespaced = true;

exports.state = () => ({
  localAuthToken: localAuthToken,
  localUser: localUser,
  users: [],
  specialists: [],
  loading: {
    auth: 0,
    list: 0,
    signup: 0,
    update: 0,
    delete: 0,
    sendCode: 0,
    updatePass: 0,
    specialists: 0
  },
  roles: [
    {
      text: 'Партнер',
      value: 'partner',
    },
    {
      text: 'Редактор',
      value: 'editor' 
    },
    {
      text: 'Администратор',
      value: 'admin'
    },
  ],
});

exports.getters = {
  isAdmin: state => state.localUser && state.localUser.role == 'admin',
  isEditor: state => state.localUser && state.localUser.role == 'editor',
  isPartner: state => state.localUser && state.localUser.role == 'partner',
  isLoggedIn: state => Boolean(state.localAuthToken),
  isLoading: state => action => state.loading[action] != 0,
  getUserById: state => id => state.users.find(x => x._id == id),
  partnerUsers: state => state.users.filter(x => x.role == 'partner'),
  loadingAuth: state => state.loading.auth != 0,
  loadingList: state => state.loading.list != 0,
  loadingSignup: state => state.loading.signup != 0,
  loadingUpdate: state => state.loading.update != 0,
  loadingDelete: state => state.loading.delete != 0,
  loadingSendCode: state => state.loading.sendCode != 0,
  loadingUpdatePass: state => state.loading.updatePass != 0,
  loadingSpecialists: state => state.loading.specialists != 0,
};

exports.mutations = {
  SET_AUTH_DATA(state, { token, user }) {
    state.localAuthToken = token;
    state.localUser = user;
  },
  SET_USERS_LIST(state, users) {
    state.users = users;
  },
  SET_SPECIALISTS_LIST(state, specialists) {
    state.specialists = specialists;
  },
  SET_LOADING_STATUS(state, action) {
    state.loading[action]++;
  },
  REMOVE_LOADING_STATUS(state, action) {
    state.loading[action]--;
  },
};

exports.actions = {
  // Авторизация в приложении
  async processAuth({ commit }, { email, password }) {
    commit('SET_LOADING_STATUS', 'auth');
    commit('SET_AUTH_DATA', {
      token: null, 
      user: null
    });
    localStorage.removeItem('authToken');
    localStorage.removeItem('userId');
    localStorage.removeItem('userName');
    localStorage.removeItem('userRole');

    try {
      let res = await axios.post(BASE_URL + 'login/', { email: email.trim(), password });
      commit('SET_AUTH_DATA', {
        token: res.data.authToken, 
        user: res.data.user
      });

      localStorage.setItem('authToken', res.data.authToken);
      localStorage.setItem('userId', res.data.user._id);
      localStorage.setItem('userName', res.data.user.firstName + ' ' + res.data.user.familyName);
      localStorage.setItem('userRole', res.data.user.role);

      axios.defaults.headers.common['authToken'] = res.data.authToken;

      return res.data;
    } catch(err) {
      //alert(1);
      throw err.response.data;
    } finally {
      commit('REMOVE_LOADING_STATUS', 'auth');
    }
  },

  // Авторизация в любом аккаунте пользователя
  async adminAuth({ commit }, userId) {
    try {
      // Сохраняем данные админа
      localStorage.setItem('adminUserData', JSON.stringify({
        authToken: localStorage.getItem('authToken'),
        userId: localStorage.getItem('userId'),
        userName: localStorage.getItem('userName'),
        userRole: localStorage.getItem('userRole'),
      }));
        
      let res = await axios.post(BASE_URL + 'admin-login/',{ userId });
      commit('SET_AUTH_DATA', {
        token: res.data.authToken, 
        user: res.data.user
      });
      localStorage.setItem('authToken', res.data.authToken);
      localStorage.setItem('userId', res.data.user._id);
      localStorage.setItem('userName', res.data.user.firstName + ' ' + res.data.user.familyName);
      localStorage.setItem('userRole', res.data.user.role);
      axios.defaults.headers.common['authToken'] = res.data.authToken;

      return res.data;
    } catch(err) {
      throw err.response.data;
    }
  },

  // Выход из приложения
  logout({ commit }) {
    localStorage.removeItem('authToken');
    localStorage.removeItem('userId');
    localStorage.removeItem('userName');
    localStorage.removeItem('userRole');
    
    commit('SET_AUTH_DATA', {
      token: null, 
      user: null
    });

    // Восстанавливаем данные Админа - если есть
    if (localStorage.getItem('adminUserData')) {
      let adminData = JSON.parse(localStorage.getItem('adminUserData'));
      commit('SET_AUTH_DATA', {
        token: adminData.authToken, 
        user: {
          _id: adminData.userId,
          name: adminData.userName,
          role: adminData.userRole
        }
      });
      localStorage.setItem('authToken', adminData.authToken);
      localStorage.setItem('userId', adminData.userId);
      localStorage.setItem('userName', adminData.userName);
      localStorage.setItem('userRole', adminData.userRole);
      axios.defaults.headers.common['authToken'] = adminData.authToken;

      localStorage.removeItem('adminUserData');
    }
  },

  // Загрузка списка доступных пользователей
  async loadList({ commit, dispatch }) {
    commit('SET_LOADING_STATUS', 'list');

    try {
      let res = await axios.get(BASE_URL);
      //console.log(res);
      commit('SET_USERS_LIST', res.data);
    } catch (err) {
      dispatch('showMessage', err.response.data.message, { root: true });
    } finally {
      commit('REMOVE_LOADING_STATUS', 'list');
    }
  },

  // Загрузка списка доступных Мастеров
  async loadSpecialists({ commit, dispatch }) {
    commit('SET_LOADING_STATUS', 'specialists');
    try {
      let res = await axios.get(BASE_URL + 'specialists');
      //console.log(res);
      commit('SET_SPECIALISTS_LIST', res.data);
    } catch (err) {
      dispatch('showMessage', err.response.data.message, { root: true });
    } finally {
      commit('REMOVE_LOADING_STATUS', 'specialists');
    }
  },

  // Регистрация нового пользователя
  async signup({ commit, dispatch, getters }, user) {
    commit('SET_LOADING_STATUS', 'signup');
    try {
      const res = await axios.post(BASE_URL + (getters.isAdmin ? '' : 'self-signup'), user);
      if (getters.isAdmin) dispatch('loadList');
      return res.data;
    } catch(err) {
      throw err.response.data;
    } finally {
      commit('REMOVE_LOADING_STATUS', 'signup');
    }
  },

  // Удаление пользователя по id
  async delete({ commit, dispatch }, id) {
    commit('SET_LOADING_STATUS', 'delete');
    try {
      const res = await axios.delete(BASE_URL + id);
      dispatch('loadList');
      return res.data;
    } catch(err) {
      throw err.response.data;
    } finally {
      commit('REMOVE_LOADING_STATUS', 'delete');
    }
  },

  async deleteSpecialist({ commit, dispatch }, id) {
    //commit('SET_LOADING_STATUS', 'delete');
    try {
      const res = await axios.delete(BASE_URL + 'specialists/' + id);
      dispatch('loadSpecialists');
      return res.data;
    } catch(err) {
      throw err.response.data;
    } finally {
      //commit('REMOVE_LOADING_STATUS', 'delete');
    }
  },

  // Обновление информации о пользователе
  async update({ commit, dispatch }, user) {
    commit('SET_LOADING_STATUS', 'update');
    try {
      const res = await axios.patch(BASE_URL + user._id, user);
      dispatch('loadList');
      return res.data;
    } catch(err) {
      throw err.response.data;
    } finally {
      commit('REMOVE_LOADING_STATUS', 'update');
    }
  },

  // Отправка кода для восстановления
  async sendRecoveryCode({ commit, dispatch }, email) {
    commit('SET_LOADING_STATUS', 'sendCode');
    try {
      const res = await axios.get(BASE_URL + 'recovery-password/' + email);
      return res.data;
    } catch(err) {
      throw err.response.data;
    } finally {
      commit('REMOVE_LOADING_STATUS', 'sendCode');
    }
  },

  // Восстановление пароля по коду
  async updatePassword({ commit, dispatch }, code) {
    commit('SET_LOADING_STATUS', 'updatePass');
    try {
      const res = await axios.get(BASE_URL + 'update-password/' + code);
      return res.data;
    } catch(err) {
      throw err.response.data;
    } finally {
      commit('REMOVE_LOADING_STATUS', 'updatePass');
    }
  },

}

export default exports;

